"use client";

import React from "react";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { cn } from "@/lib/utils";
const faqs = [{
  question: "How do I begin the home buying process in Orange County?",
  answer: "Starting your journey is simple. We begin with a personalized consultation to understand your lifestyle, budget, and goals. From there, I'll guide you through getting pre-approved for a mortgage and setting up a tailored property search that fits your specific needs in the Orange County market."
}, {
  question: "Do you specialize in first-time homebuyers?",
  answer: "Yes, absolutely. I specialize in helping first-time buyers navigate the complexities of the real estate market. I provide transparent, step-by-step guidance from the initial search to the closing table, ensuring you feel confident and informed at every stage."
}, {
  question: "What areas do you cover besides Orange County?",
  answer: "While my primary focus and deep local expertise are rooted in Orange County, New York, I extensively cover the Hudson Valley and surrounding regions. My goal is to find you the perfect home, and I leverage my network and market knowledge to support your needs wherever they may lead within the region."
}, {
  question: "How do you determine the value of a home?",
  answer: "I utilize a comprehensive market analysis that considers recent sales of comparable properties, current market trends, and the unique features of the home. This data-driven approach ensures that whether you are buying or selling, you have a realistic and competitive understanding of property value."
}, {
  question: "What makes your agency different from others?",
  answer: "Find a home with chris is built on transparency, responsiveness, and deep community ties. Unlike larger, impersonal firms, I offer a tailored experience where your unique needs are the priority. I focus on building lasting relationships and simplifying the real estate journey for every client."
}];
export default function CommonQuestions() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll();
  return <section id="common-questions" ref={ref} className={cn("py-20 bg-[#000000] transition-opacity duration-700", isVisible ? "opacity-100" : "opacity-0")}>
      <div className="container mx-auto px-4">
        <div className="max-w-[800px] mx-auto">
          <div className="text-center mb-12">
            <h2 className="text-3xl md:text-4xl lg:text-5xl font-serif text-[#FFD700] mb-4">
              Common Questions
            </h2>
            <p className="text-white/80 text-lg max-w-2xl mx-auto">
              Everything you need to know about buying and investing in
              Orange County and Hudson Valley real estate.
            </p>
          </div>

          <Accordion type="single" collapsible className="w-full space-y-4">
            {faqs.map((faq, i) => <AccordionItem key={i} value={`item-${i}`} data-index={i} className="border border-[#FFD700]/30 rounded-lg px-4 data-[state=open]:bg-[#DC143C]/10 data-[state=open]:border-[#FFD700] transition-all duration-300">
                <AccordionTrigger className="font-serif text-xl text-white hover:no-underline hover:text-[#FFD700] py-5 text-left">
                  {faq.question}
                </AccordionTrigger>
                <AccordionContent className="text-white/70 text-base leading-relaxed pb-6">
                  {faq.answer}
                </AccordionContent>
              </AccordionItem>)}
          </Accordion>
        </div>
      </div>
    </section>;
}